<div class="containerImage" [style.background-image]="'url(assets/login/' + appID + '/bg.jpg)'">
    <div class="container">

        <!--Display at smaller resolutions-->
        <ng-container *ngIf="(app.innerWidth < 850)" loginContainerMobile>
            <div class="rightLoginLeaf mat-elevation-z8">
                <div class="leftLeafOverlayMobile">
                    <div class="roles">
                        <img [src]="appLogo" height="60px"
                            style="padding-top: 20px;">
                    </div>

                    <span class="login-logo-for-text" *ngIf="orgLogo"><i>For</i></span>
                    
                    <div class="org-logo" >
                        <img [src]="orgLogo" height="35px">
                    </div>
                </div>
                                 
                <div *ngIf="submitMessage" class="submitMessage">
                    {{ submitMessage }}
                </div>

                <div class="roles rightLeafOverlay">
                    <h2 style="padding-bottom: 10px">Choose One:</h2>
                    <div class='loginButtonContainer'>
                        <button class="mat-flat-button role"
                            [class.selected]="parentNavID === +topNav.data.nav"
                            *ngFor="let topNav of topNavs"
                            [routerLink]="['/' + topNav.path]">
                            {{topNav.data.label}}
                        </button>
                    </div>
                </div>

                <form autocomplete="on" class="loginForm" [formGroup]="formGroup" (ngSubmit)="submitForm()">
                    <ng-container *ngFor="let field of form.fields | keyvalue: originalOrder">
                            <app-textfield *ngIf="field.value.type === 'text'" (blurEvent)="fieldValidate(field, $event)" [field]="field.value" [fieldKey]="field.key"
                                [formGroup]="this.formGroup"></app-textfield>
                            <app-password *ngIf="field.value.type === 'password'" [field]="field.value" [fieldKey]="field.key"
                                [formGroup]="this.formGroup"></app-password>
                        </ng-container>
                    <button mat-raised-button class="loginButton" type="submit">Login</button>
                </form>

                <!-- For V1 apps, these link aren't working, but these pages aren't currently being used. Once V1 users login from V2, they must be repaired. -->
                <div class="links">
                    <ng-container *ngFor="let link of links; let last = last">
                        <a [routerLink]="link.link">{{link.label}}</a>
                        <span *ngIf="!last"> | </span>
                    </ng-container>
                </div>
            </div>
        </ng-container>

        <!-- Display For Desktop View-->
        <ng-container *ngIf="(app.innerWidth >= 850)">
            <div class="mat-elevation-z8 loginContainer">
                <div class="leftLoginLeaf" [style.background-image]="'url(assets/login/' + appID + '/side_bg.jpg)'">
                    <div class="leftLeafOverlay">
                        <div class="logoStack" [class.white-bg-box]="orgLogo">
                            <div class="roles">
                                <img [src]="appLogo" width="300px"
                                    style="padding-top: 20px;">
                            </div>

                            <span class="login-logo-for-text" *ngIf="orgLogo">For</span>
                            
                            <div class="org-logo" >
                                <img [src]="orgLogo" height="60px">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rightLoginLeaf">
                    <div class="loginSuccess"></div>                    
                    <div *ngIf="submitMessage" class="submitMessage">
                        {{ submitMessage }}
                    </div>
                    
                    <div class="roles rightLeafOverlay">
                        <h2 style="padding-bottom: 10px;">Choose One:</h2>
                        <div class='loginButtonContainer'>
                            <button class="mat-flat-button role"
                                [class.selected]="parentNavID === +topNav.data.nav"
                                *ngFor="let topNav of topNavs"
                                [routerLink]="['/' + topNav.path]"
                                [queryParams]="getQueryParams()">
                                {{topNav.data.label}}
                            </button>
                        </div>
                    </div>

                    <form autocomplete="on" class="loginForm" [formGroup]="formGroup" (ngSubmit)="submitForm()">
                        <ng-container *ngFor="let field of form.fields | keyvalue: originalOrder">
                            <app-textfield *ngIf="field.value.type === 'text'" (blurEvent)="fieldValidate(field, $event)" [field]="field.value" [fieldKey]="field.key"
                                [formGroup]="this.formGroup"></app-textfield>
                            <app-password *ngIf="field.value.type === 'password'" [field]="field.value" [fieldKey]="field.key"
                                [formGroup]="this.formGroup"></app-password>
                        </ng-container>
                        
                        <button mat-raised-button class="loginButton" type="submit">Login</button>
                    </form>

                    <!-- For V1 apps, these link aren't working, but these pages aren't currently being used. Once V1 users login from V2, they must be repaired. -->
                    <div class="links">
                        <ng-container *ngFor="let link of links; let last = last">
                            <a [routerLink]="link.link"
                            [queryParams]="getQueryParams()">{{link.label}}</a>
                            <span *ngIf="!last"> | </span>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>